import { categoriesCRUDUrl, categoryListUrl, domainsCRUDUrl, domainsListUrl, subcategoriesCRUDUrl } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getDomains = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(domainsListUrl + `${query || ""}`, config);

    return response;
};

export const postDomain = async (data) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(domainsCRUDUrl, data, config);
    return response;
};

export const patchDomain = async ({ data, id }) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(domainsCRUDUrl + id + "/", data, config);
    return response;
};

export const getCategories = async ({ query, domainId }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(domainsListUrl + domainId + "/categories/" + `${query || ""}`, config);

    return response;
};

export const postCategory = async (data) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(categoriesCRUDUrl, data, config);
    return response;
};

export const patchCategory = async ({ data, id }) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(categoriesCRUDUrl + id + "/", data, config);
    return response;
};

export const getSubCategories = async ({ query, categoryId }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(categoryListUrl + categoryId + "/subcategories/" + `${query || ""}`, config);

    return response;
};

export const postSubCategory = async (data) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(subcategoriesCRUDUrl, data, config);
    return response;
};

export const patchSubCategory = async ({ data, id }) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(subcategoriesCRUDUrl + id + "/", data, config);
    return response;
};
